import { MapPin, Phone, Mail, MessageCircle } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-brand-primary text-white" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-16 lg:py-20 grid lg:grid-cols-3 gap-12">
        <div>
          <img src="/logos/vertical1.png" alt="Galleti Advogados" className="h-16 w-auto mb-6" style={{ filter: "brightness(0) invert(1)" }} />
          <p className="text-white/70 text-sm leading-relaxed max-w-sm">
            Carlos Afonso Galleti Junior Advogados Associados. Advocacia estratégica, técnica e humanizada
            para pessoas e empresas.
          </p>
        </div>

        <div>
          <p className="eyebrow text-brand-accent mb-5">Encontre-nos</p>
          <ul className="space-y-4 text-sm text-white/80">
            <li className="flex gap-3">
              <MapPin size={18} className="text-brand-accent flex-shrink-0 mt-0.5" />
              <span>Rua Santa Luzia, 48 — conjunto 38<br />Liberdade — CEP 01503-030<br />São Paulo / SP</span>
            </li>
            <li className="flex items-center gap-3">
              <Phone size={18} className="text-brand-accent" />
              <a href="tel:+551131017576" className="hover:text-brand-accent link-underline" data-testid="footer-phone">
                (11) 3101-7576
              </a>
            </li>
            <li className="flex items-center gap-3">
              <MessageCircle size={18} className="text-brand-accent" />
              <a href="https://wa.me/5511976658938" target="_blank" rel="noopener noreferrer" className="hover:text-brand-accent link-underline" data-testid="footer-whatsapp">
                WhatsApp (11) 97665-8938
              </a>
            </li>
            <li className="flex items-center gap-3">
              <Mail size={18} className="text-brand-accent" />
              <a href="mailto:contato@galleti.com.br" className="hover:text-brand-accent link-underline" data-testid="footer-email">
                contato@galleti.com.br
              </a>
            </li>
          </ul>
        </div>

        <div>
          <p className="eyebrow text-brand-accent mb-5">Navegação</p>
          <ul className="space-y-3 text-sm text-white/80">
            {[
              ["#experiencia", "Sobre o escritório"],
              ["#areas-de-atuacao", "Áreas de atuação"],
              ["#diferenciais", "Diferenciais"],
              ["#faq", "Perguntas frequentes"],
              ["#contato", "Fale conosco"],
            ].map(([href, label]) => (
              <li key={href}>
                <a href={href} className="hover:text-brand-accent link-underline">{label}</a>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 lg:px-12 py-6 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-xs text-white/50 tracking-wider">
            © {new Date().getFullYear()} Galleti Advogados. Todos os direitos reservados.
          </p>
          <p className="text-[11px] text-white/40 tracking-[0.2em] uppercase">
            OAB — Conforme provimento 205/2021 do CFOAB
          </p>
        </div>
      </div>
    </footer>
  );
}
